import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class TransacaoService {
  constructor(
    private http: HttpClient
  ) { }

  obterTransacoesPorContaId(contaId, inicio, fim) {
    return this.http
      .get(urls.apiBase + '/Transacoes/ObterTransacoes?contaId=' + contaId + '&inicio=' + inicio + '&fim=' + fim);
  }

  estornar(id) {
    return this.http
      .put(urls.apiBase + '/Transacoes/Estornar?id=' + id, null);
  }

  obterTransacaoPorId(id) {
    return this.http
      .get(urls.apiBase + '/Transacoes/ObterPorId?id=' + id);
  }

  obterPorClienteId(clienteId) {
    return this.http
      .get(urls.apiBase + '/Transacoes/ObterPorClienteId?clienteId=' + clienteId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/transacao/transacao.service.ts